import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import { OrderItemRow } from '@models/order/orderLog';
import { useTranslation } from 'react-i18next';

import MyMenuBottomSheet from './MyMenuBottomSheet';

interface Props {
    orderItem: OrderItemRow;
}
function OrderItem({ orderItem }:Props) {
    const { t } = useTranslation('orderLog');
    const {
        name, salePrice, thumbnailUrl, qty, orderOptions,
    } = orderItem;
    const { openBottomSheet } = useBottomSheet();
    const openMyMenuBottomSheet = () => {
        openBottomSheet('MY메뉴 추가', <MyMenuBottomSheet/>);
    };
    const optionAmount = orderOptions
        .map((option) => option.qty * option.salePrice)
        .reduce((prev, curr) => prev + curr, 0);
    const totalAmount = (salePrice + optionAmount) * qty;
    const priceUnit = usePriceUnit();
    return (
        <Row fullWidth spacing={24} align='flex-start'>
            <ImageWrapper justify='center' align='center'>
                <Image src={thumbnailUrl}
                    width={100}
                    height={100}
                    alt={t('item.imageAlt')}/>
            </ImageWrapper>
            <Column spacing={8} fullWidth>
                <Column fullWidth>
                    <NameText size='lg' fontWeight='bold' color={colors.gray8}>
                        {name}
                    </NameText>
                    <Row fullWidth justify='space-between' align='center'>
                        <Text color={colors.gray8}>{t('item.quantity', { qty: qty.toLocaleString() })}</Text>
                        <Text size='lg' fontWeight='bold' color={colors.primary}>
                            {totalAmount.toLocaleString()}{priceUnit}
                        </Text>
                    </Row>
                </Column>
                <Column>
                    {orderOptions
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((option) => (
                            <Text color={colors.gray8}
                                key={option.optionId}>
                                {option.name}{t('item.optionPrice', { price: `${(option.qty * option.salePrice).toLocaleString()}${priceUnit}` })}
                            </Text>
                        ))}
                </Column>
            </Column>
        </Row>
    );
}

// width/height는 Column 자체의 auto 값이 우선 적용되던 기존 렌더링을 유지하기 위해 min 값만 지정
const ImageWrapper = styled(Column)`
    border-radius: 4px;
    min-height: 100px;
    min-width: 100px;
    overflow: hidden;
`;

const NameText = styled(Text)`
    white-space: pre-wrap;
    word-break: break-all;
`;

export default OrderItem;
